module.exports = __webpack_public_path__ + "img/pratichego_small.8c3f31ef.png";